module.exports = __webpack_public_path__ + "img/edff379.jpg";